jQuery(function () {
	let windowW = $(window).width();
	let bp = 1080;

	$(function () {	// メニュー
		const $btn = $('.js-menuBtns li');
		const $menuContent = '.js-menuContent';
		if (windowW <= bp) {
			$btn.on('click', function () {
				$(this).children($menuContent).toggleClass('is-show');
				$(this).toggleClass('is-active');

				if ($($menuContent).hasClass('is-show')) {
					$($menuContent).removeClass('is-show');
					$btn.removeClass('is-active');
					$(this).children($menuContent).addClass('is-show');
					$(this).addClass('is-active');
				}
				if ($('.business-menu').hasClass('is-show')) {
					$('body').addClass('is-menu-active');
				} else {
					$('body').removeClass('is-menu-active');
				}
			});

		} else {
			$btn.on('mouseover', function () {
				$($menuContent).removeClass('is-show');
				$(this).children($menuContent).addClass('is-show');
				$(this).addClass('is-active');
			});
			$btn.on('mouseleave', function () {
				$($menuContent).removeClass('is-show');
				$btn.removeClass('is-active');
			});
		}

	});

	$(function () {	// 表：高さを揃える
		const length = 9;
		let headPadding = 0;
		for (let i = 1; i <= length; i++) {
			let maxHeight = 0;
			let $target = $(`.js-fixH-${i}`);
			$target.each(function () {
				if ($(this).innerHeight() > maxHeight) {
					maxHeight = $(this).innerHeight();
				}
			});
			$target.innerHeight(maxHeight);
			if (i == 1 || i == 2) {
				headPadding = headPadding + maxHeight;
			}
		}
		if (windowW <= bp) {
			$('.blockHead').css('padding-top', headPadding + 250);
		} else {
			$('.blockHead').css('padding-top', headPadding + 311);
		}
	});

	$(function () {	// 表：幅調整
		if (windowW <= bp) {
			const tableWidth = ($('.table-wrap .block').outerWidth() + 30) * $('.table-wrap .block').length + 100;
			$('.table-wrap .group').css('width', tableWidth + 'px');
		} else {
			const tableWidth = ($('.table-wrap .block').outerWidth() + 40) * $('.table-wrap .block').length + 200;
			$('.table-wrap .group').css('width', tableWidth + 'px');
		}
	});

	$(function () {	// 表：more
		const $target = $('.js-tableMoreArea');
		const $btn = $('.js-tableMore');
		$btn.on('click', function () {
			$target.toggleClass('is-limit');
			$btn.hide()
		});
	});

	$(function () {// PC/SP改行切り替えの空白の解消
		const $br_pc = $('.m-pc'),
			$br_sp = $('.m-sp');
		if (windowW <= bp) {
			$br_pc.replaceWith('<span style="margin:0 0 0 -0.35em;"></span>');
		} else {
			$br_sp.replaceWith('<span style="margin:0 0 0 -0.35em;"></span>');
		}
	});

	
$(function(){// タブ切り替え
  let $tabBtn = $('.js-tabBtns li'),
			$tabArea = $('.js-tabArea');
  $tabBtn.on('click', function () {
		$tabBtn.removeClass('is-active');
		$tabArea.removeClass('is-show');
    $(this).addClass('is-active');
    let $index = $(this).index();
    $tabArea.eq($index).addClass('is-show');
  });
});

});